import { SET_LANG } from '../Actions/UserActions';


export default function (state = {}, action) {
    switch (action.type) {
        case SET_LANG:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/LangReducer.js